/*  ────────────────────────────────────────────────────────
    Konecta Events Database
    ──────────────────────────────────────────────────────── */

export const EVENT_CATEGORIES = [
  { value: "all", label: "All Events" },
  { value: "summit", label: "Summits" },
  { value: "forum", label: "Forums" },
  { value: "indaba", label: "Indabas" },
  { value: "conference", label: "Conferences" },
  { value: "workshop", label: "Workshops" },
  { value: "hackathon", label: "Hackathons" },
  { value: "roundtable", label: "Roundtables" },
  { value: "networking", label: "Networking" },
  { value: "webinar", label: "Webinars" },
  { value: "expo", label: "Expos & Showcases" },
  { value: "awards", label: "Awards Galas" },
];

export const EVENT_SECTORS = [
  { value: "all", label: "All Sectors" },
  { value: "private", label: "Private Sector" },
  { value: "public", label: "Public Sector" },
  { value: "government", label: "Government" },
  { value: "cross-sector", label: "Cross-Sector" },
];

export const EVENT_LOCATIONS = [
  { value: "all", label: "All Locations" },
  { value: "Johannesburg", label: "Johannesburg" },
  { value: "Cape Town", label: "Cape Town" },
  { value: "Dubai", label: "Dubai" },
  { value: "Nairobi", label: "Nairobi" },
  { value: "Lagos", label: "Lagos" },
  { value: "East London", label: "East London" },
];

export const eventsDatabase = [
  /* ── UPCOMING EVENTS ─────────────────────────────────── */
  {
    id: "witechnology-2026",
    slug: "witechnology-summit-2026",
    name: "WiTechnology Summit 2026",
    shortName: "WiTechnology",
    tagline: "Capital, Confidence & Scale",
    category: "summit",
    sector: "cross-sector",
    status: "upcoming",
    featured: true,
    badge: "Women in Technology",
    accent: "#ED1E79", // WiTechnology magenta, from the summit speaker artwork

    dateStart: "2026-08-27",
    dateEnd: "2026-08-27",
    time: "09:00 – 15:30 SAST",
    registrationDeadline: null,

    venue: "Adapt IT Campus, Midrand",
    city: "Midrand",
    country: "South Africa",
    address: "Adapt IT Campus, Midrand, Gauteng",
    mapUrl: "https://maps.google.com/?q=Adapt+IT+Campus+Midrand+South+Africa",

    image: "/images/witechnology-summit-2026/WITECHNOLOGY BANNER-UPCOMING EVENT-NEW-UP.png",
    gallery: [
      "/images/witechnology-summit-2025/gallery-hero.jpg",
      "/images/witechnology-summit-2025/dsc00006_54750561351_l.jpg",
      "/images/witechnology-summit-2025/dsc00024_54750903090_l.jpg",
    ],
    galleryLabel: "Event Recap — WiTechnology Summit 2025",

    description:
      "WiTechnology Summit 2026 brings together women leaders, entrepreneurs, investors, innovators, and ecosystem partners from across Africa's technology and digital economy sectors for a day of meaningful conversations, collaboration, and strategic engagement.",
    longDescription:
      "Now in its third year, the summit continues to build on the legacy of the WiTechAfrica platform launched in 2024, evolving into a focused platform dedicated to advancing women's participation and leadership within Africa's innovation ecosystem.\n\nThis year's theme, \"Capital, Confidence & Scale,\" responds to one of the biggest challenges facing women-led businesses globally — access to funding, investment networks, and sustainable growth opportunities.\n\nThe summit will explore practical strategies for enabling women entrepreneurs and innovators to scale their businesses, strengthen investment readiness, build sustainable partnerships, and increase visibility within the technology ecosystem.",
    overview: [
      "WiTechnology Summit 2026 brings together women leaders, entrepreneurs, investors, innovators, and ecosystem partners from across Africa's technology and digital economy sectors for a day of meaningful conversations, collaboration, and strategic engagement.",
      "Now in its third year, the summit continues to build on the legacy of the WiTechAfrica platform launched in 2024, evolving into a focused platform dedicated to advancing women's participation and leadership within Africa's innovation ecosystem.",
    ],
    programSections: [
      {
        title: "Keynote Addresses & Panel Discussions",
        body: "Thought-provoking keynote addresses and expert panel discussions from women leaders, investors, and ecosystem builders driving Africa's digital economy forward.",
      },
      {
        title: "Women-Led Innovation Showcases",
        body: "Spotlighting women entrepreneurs and innovators building scalable technology businesses and pioneering solutions across Africa's diverse markets.",
      },
      {
        title: "Investor & Networking Sessions",
        body: "Dedicated sessions connecting founders with investors, mentors, and industry leaders to forge meaningful partnerships and explore funding opportunities.",
      },
      {
        title: "Fireside Conversations",
        body: "Intimate fireside conversations with experienced founders and technology leaders sharing candid insights on scaling businesses and navigating the investment landscape.",
      },
    ],
    purposeIntro:
      "WiTechnology Summit 2026 responds directly to one of the biggest challenges facing women-led businesses globally — access to funding, investment networks, and sustainable growth opportunities.",
    highlights: [
      "Conversations on funding and investment readiness",
      "Women-led innovation and entrepreneurship showcases",
      "Networking with investors, founders, and industry leaders",
      "Digital transformation and ecosystem collaboration discussions",
      "Leadership, mentorship, and business growth opportunities",
    ],

    speakers: [
      {
        name: "Yandisa Sokhanyile",
        role: "CEO",
        company: "Konecta",
        image: "/images/speakers/yandisa-sokhanyile.jpg",
      },
      {
        name: "Nthabi Mokitimi-Dlamini",
        role: "Group Executive: Ecosystem and Stakeholder Management",
        company: "SEDFA",
        image: "/images/speakers/Nthabi Mokitimi Dlamini.png",
      },
      {
        name: "Milisa Mabinza",
        role: "Director for the UK-South African Tech Hub",
        company: "British High Commission of South Africa",
        image: "/images/speakers/Milisa Mabinza.png",
      },
      {
        name: "Sandra Machemba",
        role: "ESD Support Lead",
        company: "Adapt IT",
        image: "/images/speakers/Sandra Machemba.png",
      },
      {
        name: "Fulufhelo Ramulifho",
        role: "Founder & Director",
        company: "C4U Group",
        image:
          "/images/speakers/Fulufhelo Ramulifho - Founder & Director - C4U Group.png",
      },
      {
        name: "Jack Ngcwembe",
        role: "Business Development Manager: Corporate Client Relationship",
        company: "Aurik",
        image:
          "/images/speakers/Jack Ngcwembe - Business Development Manager Corporate Client Relationship -  Aurik.png",
      },
    ],

    agenda: [],
    tickets: [
      {
        tier: "General Admission",
        price: "R699",
        currency: "ZAR",
        perks: [
          "Full-day access",
          "All sessions & panels",
          "Networking opportunities",
          "Event materials",
        ],
        available: true,
      },
    ],
    ticketUrl: "https://tickets.konecta.co.za/event/witechnology-summit-2026/",

    capacity: "80 – 100",
    attendeeProfile:
      "Women founders, technology leaders, investors, entrepreneurs, corporate executives, SMEs, innovation ecosystem partners, government stakeholders, and digital transformation professionals.",
    sponsors: [],
    tags: [
      "Women in Technology",
      "Innovation",
      "Digital Transformation",
      "Entrepreneurship",
      "Investment",
      "Leadership",
      "Technology Ecosystems",
    ],
  },

  {
    id: "municipal-indaba-2026",
    slug: "municipal-indaba-2026",
    name: "Municipal Indaba 2026",
    shortName: "Municipal Indaba",
    tagline: "Innovation · Sustainability · Service Delivery",
    category: "indaba",
    sector: "government",
    status: "upcoming",
    featured: true,
    badge: "Government & Municipal",

    dateStart: "2026-04-22",
    dateEnd: "2026-04-23",
    time: "08:30 – 15:30 SAST",
    registrationDeadline: "2026-04-15",

    venue: "East London International Convention Centre",
    city: "KuGompo",
    country: "South Africa",
    address:
      "Esplanade, 22 Esplanade St, Quigney, KuGompo, Eastern Cape 5201",
    mapUrl:
      "https://maps.google.com/maps?q=Esplanade%2C+22+Esplanade+St%2C+Quigney%2C+South+Africa+East+London+Eastern+Cape+5201+South+Africa",

    image: "/images/municipal-indaba-2026/banner-image.jpg",
    imagePosition: "center 40%",
    gallery: [
      "/images/municipla-indaba-2024/IMG_20240221_144613-scaled.jpeg",
      "/images/municipla-indaba-2024/Indaba-Group-picture.jpg",
      "/images/municipla-indaba-2024/KhathuMapula.jpeg",
    ],
    galleryLabel: "Gallery — Municipal Indaba 2024 (Past Event)",

    description:
      "The Municipal Indaba 2026, hosted by Konecta, brings together key stakeholders across local government, the public and private sectors, civil society, and development partners to reimagine local governance through digital transformation and artificial intelligence.",
    longDescription:
      "This year's theme, 'Rethinking Local Governance: Innovation, Sustainability, and Service Delivery', aims to explore how technology and innovation can drive smarter, more inclusive, and citizen-centred public service delivery. The Indaba will feature thought-provoking discussions and expert insights on key governance challenges and opportunities.",
    overview: [
      "The Municipal Indaba 2026, hosted by Konecta, brings together key stakeholders across local government, the public and private sectors, civil society, and development partners to reimagine local governance through digital transformation and artificial intelligence.",
      "This year's theme — 'Rethinking Local Governance: Innovation, Sustainability, and Service Delivery' — explores how technology and innovation can drive smarter, more inclusive, and citizen-centred public service delivery, with thought-provoking discussions and expert insights on key governance challenges and opportunities.",
    ],
    purposeIntro:
      "The Indaba addresses seven critical themes shaping the future of local governance, digital transformation, and smart city development:",
    highlights: [
      "The Future of Local Government: Rethinking Governance in the Age of Digital Transformation",
      "Bridging the Digital Divide: Smart Infrastructure and Inclusive Municipalities",
      "Modernising Municipal Finance Through Technology and Partnerships",
      "Revenue & Data Management",
      "Critical Infrastructure Protection",
      "Turnaround Strategies & Municipal Funding",
      "Enabling Smart Municipalities Through Connectivity and Digital Infrastructure",
    ],
    themes: [
      {
        title: "The Future of Local Government: Rethinking Governance in the Age of Digital Transformation",
        description:
          "Exploring how digital transformation, AI, and smarter operational models are reshaping the future of municipal governance and service delivery.",
      },
      {
        title: "Bridging the Digital Divide: Smart Infrastructure and Inclusive Municipalities",
        description:
          "Examining how connectivity, smart infrastructure, and strategic partnerships can drive more inclusive and digitally connected municipalities.",
      },
      {
        title: "Modernising Municipal Finance Through Technology and Partnerships",
        description:
          "Showcasing how technology and collaboration can improve revenue collection, procurement, financial oversight, and operational efficiency.",
      },
      {
        title: "Revenue & Data Management",
        description:
          "Focusing on practical strategies to optimise municipal revenue, improve data accuracy, and strengthen billing and debt management systems.",
      },
      {
        title: "Critical Infrastructure Protection",
        description:
          "Exploring practical approaches to strengthening municipal infrastructure protection through governance, risk management, and enabling technologies.",
      },
      {
        title: "Turnaround Strategies & Municipal Funding",
        description:
          "Providing actionable strategies to improve municipal performance, unlock sustainable funding, and strengthen financial resilience.",
      },
      {
        title: "Enabling Smart Municipalities Through Connectivity and Digital Infrastructure",
        description:
          "Highlighting how strategic collaboration and digital infrastructure can enable smarter, more connected, and future-ready municipalities.",
      },
    ],

    speakers: [
      {
        name: "Yandisa Sokhanyile",
        company: "Konecta",
        image: "/images/speakers/municipal-indaba-2026/Yandisa Sokhanyile - Konecta.png",
      },
      {
        name: "Miyelani Holeni",
        company: "Ntiyiso Consulting",
        image: "/images/speakers/municipal-indaba-2026/Miyelani Holeni - Ntinyiso Consulting.png",
      },
      {
        name: "Monde Sikiti",
        company: "Sentech",
        image: "/images/speakers/municipal-indaba-2026/Monde Sikiti - Sentech.png",
      },
      {
        name: "Christo van Tonder",
        company: "Storm Solution",
        image: "/images/speakers/municipal-indaba-2026/Christo van Tonder - Storm Solution.png",
      },
      {
        name: "Khatu Raphunga",
        company: "Sentech",
        image: "/images/speakers/municipal-indaba-2026/Khatu Raphunga - Sentech.png",
      },
      {
        name: "Lwarence Khoza",
        company: "Link Africa",
        image: "/images/speakers/municipal-indaba-2026/Lwarence Khoza - Link Africa.png",
      },
      {
        name: "Malungelo Mtati",
        company: "SALGA",
        image: "/images/speakers/municipal-indaba-2026/Malungelo Mtati - SALG.png",
      },
      {
        name: "Paul Smith",
        company: "Kagiso Trust",
        image: "/images/speakers/municipal-indaba-2026/Paul Smith - Kagiso Trust.png",
      },
      {
        name: "Progres Sondlane",
        company: "Sondlane Telecoms",
        image: "/images/speakers/municipal-indaba-2026/Progres Sondlane - Sondlane Telecoms.png",
      },
      {
        name: "Thina Dlulane",
        company: "KXX Auditors",
        image: "/images/speakers/municipal-indaba-2026/Thina Dlulane - KXX Auditors.png",
      },
      {
        name: "Tswakai Luke",
        company: "COGTA",
        image: "/images/speakers/municipal-indaba-2026/Tswakai Luke - COGTA.png",
      },
    ],

    agenda: [
      {
        day: "Day 1 — 22 April: Keynote Addresses, Presentations & Panel Discussions",
        sessions: [
          {
            time: "08:30 – 09:00",
            title: "Registration & Networking Breakfast",
            description:
              "Arrival of delegates, welcome refreshments, exhibitor walkabout",
            type: "networking",
          },
          {
            time: "09:00 – 09:45",
            title: "Opening & Welcome Remarks",
            description:
              "Welcome from organisers, overview of the Indaba, setting the tone",
            type: "keynote",
          },
          {
            time: "09:45 – 10:15",
            title: "Opening Keynote: The Future of Local Government",
            description:
              "Rethinking Governance in the Age of Digital Transformation",
            type: "keynote",
          },
          {
            time: "10:15 – 11:30",
            title: "Panel 1: Digital Transformation in Municipal Operations",
            description:
              "AI, Cybersecurity & Digital Infrastructure for Secure Municipal Management — Focus: AI in service delivery, structured cybersecurity infrastructure protection, data governance, and risk management",
            type: "panel",
          },
          {
            time: "11:30 – 12:45",
            title: "Panel 2: Smart & Inclusive Cities",
            description:
              "Bridging the Digital Divide: Smart Infrastructure and Inclusive Municipalities — Focus: Connectivity, smart infrastructure, citizen access, digital inclusion",
            type: "panel",
          },
          {
            time: "12:45 – 13:00",
            title: "Q & A",
            type: "panel",
          },
          {
            time: "13:00 – 14:00",
            title: "Lunch Break & Networking",
            type: "break",
          },
          {
            time: "14:00 – 15:15",
            title: "Panel 3: Financial Innovation & Collaborative Governance",
            description:
              "Modernising Municipal Finance Through Technology and Partnerships — Focus: Revenue optimisation, transparency, data-driven finance, partnerships, funding models",
            type: "panel",
          },
          {
            time: "15:15 – 15:30",
            title: "Day 1 Wrap-Up",
            description:
              "Summary of key insights, takeaways for municipalities",
            type: "networking",
          },
        ],
      },
      {
        day: "Day 2 — 23 April: Workshops & Technology Demonstrations",
        sessions: [
          {
            time: "08:30 – 09:00",
            title: "Registration & Morning Networking",
            description: "Arrival, coffee, and informal networking",
            type: "networking",
          },
          {
            time: "09:00 – 10:30",
            title: "Workshop 1: Revenue & Data Management",
            description:
              "Kagiso Trust — Practical, interactive session on optimising municipal revenue and data management",
            type: "workshop",
          },
          {
            time: "10:30 – 11:00",
            title:
              "Workshop 2: Unpacking Digital Transformation for Municipalities",
            description:
              "Konecta — Exploring digital frameworks, innovative solutions, and strategies to accelerate service delivery through technology, including how to procure software efficiently via the Microsoft Marketplace",
            type: "workshop",
          },
          {
            time: "11:00 – 11:30",
            title: "Tea Break",
            description: "Light refreshments and networking",
            type: "break",
          },
          {
            time: "11:30 – 13:00",
            title: "Workshop 3: Turnaround Strategies & Municipal Funding",
            description:
              "KNM — Practical insights into improving municipal performance, funding strategies, and implementing turnaround plans for sustainable service delivery",
            type: "workshop",
          },
          {
            time: "13:00 – 14:00",
            title: "Lunch Break",
            description: "Attendees network over lunch and visit stands",
            type: "break",
          },
          {
            time: "14:00 – 15:30",
            title:
              "Workshop 4: Enabling Smart Municipalities Through Connectivity & Digital Infrastructure",
            description:
              "Sentech — Showcasing infrastructure solutions, connectivity, and digital platforms that enable smarter, more efficient municipalities",
            type: "workshop",
          },
          {
            time: "15:30",
            title: "Closing Remarks & Wrap-Up",
            type: "networking",
          },
        ],
      },
    ],

    capacity: "60+ attendees",
    attendeeProfile:
      "Mayors, Municipal Managers, Government CIOs, IT Directors, Civil Society, Development Partners",
    sponsors: [
      "Konecta",
      "Sentech",
      "Kagiso Trust",
      "KNM",
      "Ntinyiso Consulting",
      "Khumalo Xaba Xulu Auditors",
    ],
    tags: [
      "Future of Local Government",
      "Bridging the Digital Divide",
      "Municipal Finance & Technology",
      "Revenue & Data Management",
      "Critical Infrastructure Protection",
      "Turnaround Strategies & Funding",
      "Smart Municipalities",
    ],
  },

  /* ── PAST EVENTS ─────────────────────────────────────── */
  {
    id: "cio-konect-2025",
    slug: "cio-konect-summit-2025",
    name: "CIO Konect Summit 2025",
    shortName: "CIO Konect",
    tagline: "Shaping the Future of Technology Leadership in Africa",
    category: "summit",
    sector: "cross-sector",
    status: "past",
    featured: false,
    badge: "Flagship Annual Summit",

    dateStart: "2025-05-22",
    dateEnd: "2025-05-22",
    time: "Full Day",
    registrationDeadline: null,

    venue: "Adapt IT Offices, Johannesburg",
    city: "Johannesburg",
    country: "South Africa",
    address: "Adapt IT Offices, Johannesburg",
    mapUrl: "https://maps.google.com/?q=Adapt+IT+Johannesburg+Campus",

    image: "/images/cio-konect-2025/cover.jpg",
    gallery: [
      "/images/cio-konect-2025/gallery-1.jpg",
      "/images/cio-konect-2025/gallery-2.jpg",
      "/images/cio-konect-2025/gallery-3.jpg",
      "/images/cio-konect-2025/gallery-4.jpg",
    ],
    galleryLabel: "Event Recap — CIO Konect Summit 2025",

    description:
      "Konecta proudly participated in the prestigious CIO-Konect 2025, a premier event that brought together South Africa's most influential Chief Information Officers, technology executives, and industry leaders for a day of insight, innovation, and forward-thinking dialogue at the Adapt IT offices in Johannesburg.",
    longDescription: "",
    overview: [
      "Konecta proudly participated in the prestigious CIO-Konect 2025, a premier event that brought together South Africa's most influential Chief Information Officers, technology executives, and industry leaders for a day of insight, innovation, and forward-thinking dialogue at the Adapt IT offices in Johannesburg.",
      "CIO-Konect is a well-established platform for technology decision-makers, and this year's edition was no exception. It provided a dynamic space for discussions on the critical trends shaping the future of technology leadership in Africa.",
    ],
    programSections: [
      {
        title: "Keynote Addresses",
        body: "Visionary talks from leading CIOs and technology executives on the evolving landscape of digital transformation, AI integration, and the strategic role of technology in driving organisational success.",
      },
      {
        title: "Expert Panel Discussions",
        body: "Engaging panels that tackled pressing issues such as cybersecurity, cloud adoption, data governance, and the future of work. Panellists shared real-world experiences and strategic insights.",
      },
      {
        title: "Networking Opportunities",
        body: "Invaluable networking sessions that facilitated meaningful connections between technology leaders, solution providers, and innovators, fostering potential collaborations and partnerships.",
      },
      {
        title: "Innovation Showcases",
        body: "Cutting-edge technology demonstrations and solution showcases that highlighted the latest advancements and their practical applications for enterprise environments.",
      },
    ],
    purposeIntro:
      "Our participation at CIO-Konect underscores Konecta's commitment to being at the forefront of technological innovation and its deep connection to the African tech leadership community.",
    highlights: [
      "Thought Leadership: Engaging with top CIOs to understand the evolving needs of enterprise technology and contributing to discussions on best practices and emerging trends",
      "Strategic Partnerships: Building and strengthening relationships with key decision-makers who are driving digital transformation across various industries",
      "Market Positioning: Showcasing Konecta's capabilities in Wi-Fi-as-a-Service, managed IT solutions, and digital platforms to an audience of influential technology buyers",
      "Industry Insight: Gaining valuable insights into the challenges and opportunities facing CIOs and IT leaders in the current rapidly-changing technological landscape",
    ],

    speakers: [],

    agenda: [],
    tickets: [],
    ticketUrl: "",

    capacity: null,
    attendeeProfile: "CIOs, CTOs, IT Directors, Technology Executives",
    sponsors: [],
    tags: [
      "CIO",
      "Digital Transformation",
      "AI",
      "Cybersecurity",
      "Cloud",
      "Leadership",
    ],
  },

  {
    id: "witechnology-2025",
    slug: "witechnology-forum-2025",
    name: "WiTechnology Summit 2025",
    shortName: "WiTechnology",
    tagline: "Women · Innovation · African Tech",
    category: "summit",
    sector: "cross-sector",
    status: "past",
    featured: false,
    badge: "Women in Technology",
    accent: "#ED1E79", // WiTechnology magenta

    dateStart: "2025-08-27",
    dateEnd: "2025-08-27",
    time: "Full Day",
    registrationDeadline: null,

    venue: "Midrand",
    city: "Midrand",
    country: "South Africa",
    address: "Midrand, Gauteng",
    mapUrl: "https://maps.google.com/?q=Midrand+Gauteng+South+Africa",

    image: "/images/witechnology-summit-2025/cover.jpg",
    gallery: [
      "/images/witechnology-summit-2025/gallery-hero.jpg",
      "/images/witechnology-summit-2025/dsc00006_54750561351_l.jpg",
      "/images/witechnology-summit-2025/dsc00024_54750903090_l.jpg",
      "/images/witechnology-summit-2025/dsc00027_54750902850_l.jpg",
      "/images/witechnology-summit-2025/dsc00045_54750902485_l.jpg",
      "/images/witechnology-summit-2025/dsc00057_54750902200_l.jpg",
      "/images/witechnology-summit-2025/dsc00062_54750558826_l.jpg",
      "/images/witechnology-summit-2025/dsc00064_54750778164_l.jpg",
      "/images/witechnology-summit-2025/dsc00066_54750778034_l.jpg",
      "/images/witechnology-summit-2025/dsc00074_54750558261_l.jpg",
      "/images/witechnology-summit-2025/dsc00078_54750769258_l.jpg",
      "/images/witechnology-summit-2025/dsc00085_54750768803_l.jpg",
      "/images/witechnology-summit-2025/dsc00089_54750768793_l.jpg",
      "/images/witechnology-summit-2025/dsc00109_54749709117_l.jpg",
      "/images/witechnology-summit-2025/dsc00141_54750898810_l.jpg",
      "/images/witechnology-summit-2025/dsc00194_54750773349_l.jpg",
      "/images/witechnology-summit-2025/dsc00207_54750772404_l.jpg",
      "/images/witechnology-summit-2025/dsc00209_54750772059_l.jpg",
      "/images/witechnology-summit-2025/dsc00211_54749704372_l.jpg",
      "/images/witechnology-summit-2025/dsc00214_54749704152_l.jpg",
      "/images/witechnology-summit-2025/dsc00259_54750762453_l.jpg",
      "/images/witechnology-summit-2025/dsc00265_54750551126_l.jpg",
      "/images/witechnology-summit-2025/dsc00273_54750769889_l.jpg",
      "/images/witechnology-summit-2025/dsc00282_54750768864_l.jpg",
      "/images/witechnology-summit-2025/dsc00315_54750768279_l.jpg",
      "/images/witechnology-summit-2025/dsc00322_54750768174_l.jpg",
      "/images/witechnology-summit-2025/dsc00336_54749700182_l.jpg",
      "/images/witechnology-summit-2025/dsc00341_54750759733_l.jpg",
      "/images/witechnology-summit-2025/dsc00384_54750757253_l.jpg",
      "/images/witechnology-summit-2025/dsc00398_54750887725_l.jpg",
      "/images/witechnology-summit-2025/dsc00427_54750754618_l.jpg",
      "/images/witechnology-summit-2025/dsc00487_54750753293_l.jpg",
      "/images/witechnology-summit-2025/dsc00507_54749692492_l.jpg",
      "/images/witechnology-summit-2025/dsc00529_54750751773_l.jpg",
      "/images/witechnology-summit-2025/dsc00536_54750750543_l.jpg",
      "/images/witechnology-summit-2025/dsc00554_54749690922_l.jpg",
      "/images/witechnology-summit-2025/dsc00563_54749691552_l.jpg",
      "/images/witechnology-summit-2025/dsc00578_54750880060_l.jpg",
      "/images/witechnology-summit-2025/dsc00583_54750756789_l.jpg",
      "/images/witechnology-summit-2025/dsc00587_54750536251_l.jpg",
      "/images/witechnology-summit-2025/dsc00605_54750754884_l.jpg",
      "/images/witechnology-summit-2025/dsc00630_54750876640_l.jpg",
      "/images/witechnology-summit-2025/dsc00637_54750875570_l.jpg",
      "/images/witechnology-summit-2025/dsc07585_54750315704_l.jpg",
      "/images/witechnology-summit-2025/dsc07607_54750434245_l.jpg",
      "/images/witechnology-summit-2025/dsc07616_54750094261_l.jpg",
      "/images/witechnology-summit-2025/dsc07636_54750305553_l.jpg",
      "/images/witechnology-summit-2025/dsc07653_54750432030_l.jpg",
      "/images/witechnology-summit-2025/dsc07664_54750304608_l.jpg",
      "/images/witechnology-summit-2025/dsc07684_54750430615_l.jpg",
      "/images/witechnology-summit-2025/dsc07697_54750090396_l.jpg",
      "/images/witechnology-summit-2025/dsc07698_54750302843_l.jpg",
      "/images/witechnology-summit-2025/dsc07700_54749240462_l.jpg",
      "/images/witechnology-summit-2025/dsc07704_54750090386_l.jpg",
      "/images/witechnology-summit-2025/p2620168_54749239762_l.jpg",
      "/images/witechnology-summit-2025/p2620182_54750429000_l.jpg",
      "/images/witechnology-summit-2025/p2620190_54750301638_l.jpg",
      "/images/witechnology-summit-2025/p2620203_54750301298_l.jpg",
      "/images/witechnology-summit-2025/Image 2025-08-29 at 11.07.43 (1).jpeg",
      "/images/witechnology-summit-2025/Image 2025-08-29 at 11.07.43 (2).jpeg",
      "/images/witechnology-summit-2025/Image 2025-08-29 at 11.07.43 (3).jpeg",
      "/images/witechnology-summit-2025/Image 2025-08-29 at 11.07.43.jpeg",
      "/images/witechnology-summit-2025/Image 2025-08-29 at 11.07.44.jpeg",
      "/images/witechnology-summit-2025/Image 2025-09-05 at 09.40.06.jpeg",
    ],
    galleryLabel: "Event Recap — WiTechnology Summit 2025",

    description:
      "The WiTechnology Summit 2025, held during Women's Month, was a powerful convergence of female entrepreneurs, corporates, and government partners in Midrand — dedicated to strengthening gender equity and inclusivity in the technology and telecommunications sector.",
    longDescription:
      "The summit successfully created an inspiring and empowering atmosphere with the official launch of the WiTechnology digital marketplace platform — a new hub designed to connect, support, and spotlight women innovators.\n\nMore than just an event, the WiTechnology Summit is a catalytic platform dedicated to elevating the role of women in technology. The mission is to break barriers and create new opportunities in an industry that thrives on innovation and diversity, ultimately building an inclusive, innovative, and transformative tech community across the continent.",
    overview: [
      "The WiTechnology Summit 2025, held during Women's Month, was a powerful convergence of female entrepreneurs, corporates, and government partners in Midrand, dedicated to strengthening gender equity and inclusivity in the technology and telecommunications sector.",
      "The highlight was the official launch of the WiTechnology digital marketplace platform — a new hub designed to connect, support, and spotlight women innovators across Africa.",
    ],
    programSections: [
      {
        title: "Women's Economic Empowerment",
        body: "Championing growth through targeted support including Sedfa's Women's Desk and the upcoming R300-million Women's Entrepreneurship Fund, creating tangible pathways for women-owned tech enterprises.",
      },
      {
        title: "Collaborative Ecosystem Building",
        body: "Fostering strategic partnerships between SMMEs, established corporations, and government agencies to create a thriving and interconnected innovation ecosystem.",
      },
      {
        title: "Knowledge Sharing & Mentorship",
        body: "Enriching the dialogue with expertise from industry leaders on topics like ESD, 5G, AI, and 4IR — equipping women entrepreneurs with the knowledge to navigate and lead in the digital economy.",
      },
      {
        title: "Digital Connectivity",
        body: "Launching and growing the WiTechnology digital hub as a central resource for women innovators and entrepreneurs, connecting them to opportunities, mentors, and markets across Africa.",
      },
    ],
    purposeIntro:
      "The WiTechnology Summit is more than just an event; it's a catalytic platform dedicated to elevating the role of women in technology — breaking barriers and creating new opportunities in an industry that thrives on innovation and diversity.",
    highlights: [
      "Official launch of the WiTechnology digital marketplace platform",
      "Keynote by Yandisa Sokhanyile of Konecta: 'Fueling the Next Wave of African Tech through Enterprise and Supplier Development'",
      "Strategic government partnership: Sedfa's R300-million Women's Entrepreneurship Fund",
      "Panels and discussions from UN Women, Adapt IT, BiPTEL, and the Department of Trade and Industry",
      "Vibrant networking between aspiring entrepreneurs and established industry leaders",
      "Sponsor commitment from Motorola Solutions, Telecel Centrafrique SA, and Innovator Trust",
    ],

    speakers: [
      {
        name: "Yandisa Sokhanyile",
        role: "CEO",
        company: "Konecta",
        image: "/images/speakers/yandisa-sokhanyile.jpg",
      },
    ],

    agenda: [],
    tickets: [],
    ticketUrl: "",

    capacity: null,
    attendeeProfile:
      "Female Entrepreneurs, Corporates, Government Partners, Tech Innovators",
    sponsors: ["Motorola Solutions", "Telecel Centrafrique SA", "Innovator Trust"],
    tags: [
      "Women in Tech",
      "Digital Marketplace",
      "Entrepreneurship",
      "Innovation",
      "AI",
      "4IR",
    ],
  },

  {
    id: "witechnology-2024",
    slug: "witechnology-summit-2024",
    name: "WiTechnology Summit 2024",
    shortName: "WiTechnology",
    tagline: "Diversity · Innovation · Excellence in African Telecoms",
    category: "summit",
    sector: "cross-sector",
    status: "past",
    featured: false,
    badge: "Inaugural Summit",

    dateStart: "2024-08-29",
    dateEnd: "2024-08-29",
    time: "Full Day",
    registrationDeadline: null,

    venue: "Johannesburg",
    city: "Johannesburg",
    country: "South Africa",
    address: "Johannesburg, South Africa",
    mapUrl: "https://maps.google.com/?q=Johannesburg+South+Africa",

    image: "/images/witechnology-summit-2024/cover.webp",
    gallery: [
      "/images/witechnology-summit-2024/gallery-hero.jpeg",
      "/images/witechnology-summit-2024/gallery-1.jpeg",
      "/images/witechnology-summit-2024/gallery-2.jpeg",
      "/images/witechnology-summit-2024/gallery-3.jpeg",
      "/images/witechnology-summit-2024/gallery-4.jpeg",
    ],
    galleryLabel: "Event Recap — WiTechnology Summit 2024",

    description:
      "The inaugural WiTechnology Telecoms and Datacentre Summit 2024 marked the birth of a groundbreaking platform dedicated to championing diversity, innovation, and excellence in Africa's rapidly growing telecommunications and datacentre sectors.",
    longDescription:
      "The inaugural WiTechnology Telecoms and Datacentre Summit 2024 marked the birth of a groundbreaking platform dedicated to championing diversity, innovation, and excellence in Africa's rapidly growing telecommunications and datacentre sectors.\n\nThis landmark event brought together some of the continent's most brilliant minds, pioneering leaders, and passionate advocates for a future where technology is inclusive, transformative, and empowering for all.\n\nWiTechnology was conceived as more than a conference – it is a movement. The summit was designed to create a permanent, impactful platform addressing critical needs in the African tech ecosystem.",
    overview: [
      "The inaugural WiTechnology Telecoms and Datacentre Summit 2024 marked the birth of a groundbreaking platform dedicated to championing diversity, innovation, and excellence in Africa's rapidly growing telecommunications and datacentre sectors.",
      "This landmark event brought together some of the continent's most brilliant minds, pioneering leaders, and passionate advocates for a future where technology is inclusive, transformative, and empowering for all.",
    ],
    programSections: [
      {
        title: "Women's Empowerment",
        body: "Elevating the role of women in the telecoms and datacentre industries by creating opportunities for leadership, mentorship, and career advancement.",
      },
      {
        title: "Startup Growth & Innovation",
        body: "Providing a launchpad for startups and emerging businesses in the tech space, connecting them with investors, mentors, and established industry players.",
      },
      {
        title: "Diversity & Inclusion",
        body: "Championing a more representative and inclusive tech sector across Africa — building an ecosystem where every voice contributes to innovation.",
      },
      {
        title: "Industry Excellence",
        body: "Setting new benchmarks for excellence in African telecoms and datacentres through knowledge sharing and best practice dissemination.",
      },
    ],
    purposeIntro:
      "WiTechnology was conceived as more than a conference — it is a movement designed to create a permanent, impactful platform addressing critical needs in the African tech ecosystem.",
    highlights: [
      "Official Platform Launch: The historic unveiling of the WiTechnology platform, establishing a permanent digital home for the community",
      "Keynote by Wabo Majavu: An inspiring opening address emphasising the critical need for diversity and innovation",
      "Expert Panel Discussions: High-impact panels featuring executives from Seacom, Sentech, and Telecel SA",
      "Networking & Masterclasses: Dedicated sessions for capacity building, knowledge exchange, and forging new partnerships",
      "Focus on 5G, IoT & Digital Inclusion: Deep dives into emerging technologies and their potential to bridge the digital divide",
    ],

    speakers: [],

    agenda: [],
    tickets: [],
    ticketUrl: "",

    capacity: null,
    attendeeProfile:
      "Women in Tech, Telecoms Executives, Datacentre Leaders, Startups, Investors",
    sponsors: ["Seacom", "Sentech", "Telecel SA"],
    tags: ["Women in Tech", "Telecoms", "Datacentre", "Startups", "Diversity"],
  },

  {
    id: "municipal-indaba-2024",
    slug: "municipal-indaba-2024",
    name: "Municipal Indaba 2024",
    shortName: "Municipal Indaba",
    tagline: "Digital Transformation for Local Government",
    category: "indaba",
    sector: "government",
    status: "past",
    featured: false,
    badge: "Government & Municipal",
    imagePosition: "center 55%",

    dateStart: "2024-02-21",
    dateEnd: "2024-02-22",
    time: "08:30 – 15:30 SAST",
    registrationDeadline: "2024-02-14",

    venue: "Adapt IT Johannesburg Campus",
    city: "Johannesburg",
    country: "South Africa",
    address: "Adapt IT Johannesburg Campus",
    mapUrl: "https://maps.google.com/?q=Adapt+IT+Johannesburg+Campus",

    image: "/images/municipla-indaba-2024/Indaba-Group-picture.jpg",
    gallery: [
      "/images/municipla-indaba-2024/IMG_20240221_144613-scaled.jpeg",
      "/images/municipla-indaba-2024/Indaba-Group-picture.jpg",
      "/images/municipla-indaba-2024/KhathuMapula.jpeg",
    ],
    galleryLabel: "Event Recap — Municipal Indaba 2024",

    description:
      "The Municipal Indaba 2024, hosted by Konecta, brought together key stakeholders across local government, the public and private sectors, and development partners to explore digital transformation strategies for improved municipal service delivery.",
    longDescription:
      "Municipal Indaba 2024 focused on practical approaches to digitising local government operations and improving citizen engagement through technology. The event featured presentations and panel discussions on smart infrastructure, community Wi-Fi deployment, digital platforms for connected government, and strategies for ensuring digital inclusion across municipalities.",
    highlights: [
      "Digital transformation strategies for municipalities",
      "Smart infrastructure & community Wi-Fi discussions",
      "Government-private sector partnership facilitation",
      "Digital inclusion for underserved communities",
    ],

    speakers: [
      {
        name: "Yandisa Sokhanyile",
        role: "CEO",
        company: "Konecta",
        image: "/images/speakers/yandisa-sokhanyile.jpg",
      },
    ],

    agenda: [],
    tickets: [],
    ticketUrl: "",

    capacity: "50+",
    attendeeProfile: "Municipal Managers, Government CIOs, Councillors",
    sponsors: ["Microsoft", "Huawei"],
    tags: ["eGovernment", "Municipal", "Digital Inclusion", "Wi-Fi"],
  },
].map((event) => ({
  ...event,
  status:
    new Date((event.dateEnd || event.dateStart) + "T23:59:59") < new Date()
      ? "past"
      : "upcoming",
}));
